module.exports = __webpack_public_path__ + "static/media/aces.aff124e4.jpg";